import { render } from "./Dropdown.vue?vue&type=template&id=a99a16dc"
import script from "./Dropdown.vue?vue&type=script&lang=ts"
export * from "./Dropdown.vue?vue&type=script&lang=ts"
script.render = render

export default script